import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Logo, Footer, Card, Btn } from "./ui";
import { CLUB_BASE } from "./clubApi";
import { getMyToken } from "./device";

const STEPS = [
  ["01", "Fai il test", "Poche domande, tre minuti. Energia, sonno, digestione e la tua giornata."],
  ["02", "Ricevi il tuo punteggio", "Il tuo Indice benessere e le tre abitudini da cui partire. Subito, gratis."],
  ["03", "Una persona ti segue", "La tua incaricata prepara il tuo percorso personalizzato e ogni settimana fate il punto insieme."],
];

export default function ClubHome() {
  const mine = getMyToken();
  return (
    <div className="mx-auto max-w-md px-6 pt-10" data-testid="club-home">
      <div className="flex items-center gap-3">
        <Logo size={40} />
        <div>
          <p className="font-club-display text-xl leading-none">Diamond Club</p>
          <p className="text-[0.62rem] uppercase tracking-[0.25em] text-[#9A948A] mt-1">Il tuo percorso di benessere</p>
        </div>
      </div>
      {mine && (
        <Card className="mt-8 border-[#E5B13A]/30 flex items-center justify-between gap-3" data-testid="my-page-card">
          <p className="text-sm">Hai già la tua pagina personale.</p>
          <Link to={`${CLUB_BASE}/c/${mine}`} data-testid="my-page-link"><Btn className="px-4 py-2 text-xs">Apri la mia pagina</Btn></Link>
        </Card>
      )}
      <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="font-club-display text-4xl sm:text-5xl leading-[1.05] mt-12">
        Il tuo percorso di benessere, <span className="text-[#E5B13A]">seguito da una persona vera.</span>
      </motion.h1>
      <p className="mt-5 text-[#9A948A] leading-relaxed">
        Non un barattolo in più. Un punteggio, tre abitudini, un percorso su misura e qualcuno che ti chiede come va.
      </p>
      <div className="mt-10 space-y-3">
        {STEPS.map(([n, t, s], i) => (
          <motion.div key={n} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 + i * 0.1 }}>
            <Card className="flex gap-4">
              <span className="font-club-display text-2xl text-[#E5B13A] w-8 shrink-0">{n}</span>
              <div>
                <p className="font-semibold">{t}</p>
                <p className="text-sm text-[#9A948A] mt-1">{s}</p>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
      <Card className="mt-10 text-center">
        <p className="text-sm text-[#9A948A]">Per fare il test ti serve il link personale della tua incaricata. Chiedilo a lei su WhatsApp.</p>
      </Card>
      <Footer />
    </div>
  );
}
